"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends4 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _PrivacyPolicyTypes = _interopRequireDefault(require("../constants/PrivacyPolicyTypes"));

var _ReportsSettings = _interopRequireDefault(require("../records/ReportsSettings"));

var _SettingsActions = require("../actions/SettingsActions");

var _StagingActions = require("../actions/StagingActions");

var _pick = _interopRequireDefault(require("transmute/pick"));

var _handleActions;

var getPrivacyPolicyDefaults = function getPrivacyPolicyDefaults() {
  return (0, _immutable.fromJS)({
    privacyPolicyWording: _I18n.default.text('analyticsAndTracking.privacy.consent.privacyPolicyWording.default'),
    privacyAcceptWording: _I18n.default.text('analyticsAndTracking.privacy.consent.privacyAcceptWording.default'),
    privacyDismissWording: _I18n.default.text('analyticsAndTracking.privacy.consent.privacyDismissWording.default'),
    privacyDisclaimerWording: _I18n.default.text('analyticsAndTracking.privacy.consent.privacyDisclaimerWording.default')
  });
};

var initialState = (0, _immutable.fromJS)({
  settings: (0, _ReportsSettings.default)(),
  staged: (0, _ReportsSettings.default)()
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _SettingsActions.FetchSettingsActionTypes.SUCCESS, function (state, action) {
  var settings = (0, _ReportsSettings.default)(action.payload.data);

  if (settings.get('ipFilters') === null) {
    settings = settings.set('ipFilters', '');
  }

  if (settings.get('referrerFilters') === null) {
    settings = settings.set('referrerFilters', '');
  }

  return state.set('settings', settings).set('staged', settings);
}), (0, _defineProperty2.default)(_handleActions, _SettingsActions.SettingsActionTypes.STAGE_SETTING, function (state, action) {
  if (action.payload.key === 'privacyPolicy' && action.payload.value === _PrivacyPolicyTypes.default.NOTIFY) {
    var _extends2;

    // Stage default privacy policy values if they are null
    return state.mergeIn(['staged'], (0, _extends4.default)((_extends2 = {}, (0, _defineProperty2.default)(_extends2, action.payload.key, _PrivacyPolicyTypes.default.REQUEST_CONSENT), (0, _defineProperty2.default)(_extends2, "privacyHideDecline", action.payload.value === _PrivacyPolicyTypes.default.NOTIFY), _extends2), getPrivacyPolicyDefaults().reduce(function (acc, value, key) {
      if (state.getIn(['settings', key]) === null) {
        return Object.assign(acc, (0, _defineProperty2.default)({}, key, value));
      }

      return acc;
    }, {})));
  } else if (action.payload.key === 'privacyPolicy') {
    // Unstage privacy policy values
    return state.mergeIn(['staged'], (0, _extends4.default)((0, _defineProperty2.default)({}, action.payload.key, action.payload.value), (0, _pick.default)(getPrivacyPolicyDefaults().keySeq(), state.get('settings').toMap()).toJS()));
  }

  return state.setIn(['staged', action.payload.key], action.payload.value);
}), (0, _defineProperty2.default)(_handleActions, _StagingActions.StagingActionTypes.CLEAR_STAGED_CHANGES, function (state) {
  return state.set('staged', state.get('settings'));
}), (0, _defineProperty2.default)(_handleActions, _SettingsActions.SaveSettingsActionTypes.SUCCESS, function (state, action) {
  return state.merge({
    settings: (0, _ReportsSettings.default)(action.payload.props),
    staged: (0, _ReportsSettings.default)(action.payload.props)
  });
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;